import React from 'react';

import { EmptySectionCard, InquiryEnrollmentCard } from '@equip.health/ui';
import { isEmpty } from 'lodash';

import { InquiryEvents } from '~/analytics';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';
import { getProvidersForAvatar } from '~/lib/util/inquiry.util';
import ProviderAvatarTooltipWrapper from '~/components/common/ProviderAvatarBlockTooltipWrapper';

interface PatientInquiryListProps {
  inquiries?: GetPatientInquiriesResponse[];
  id: string;
}

const PatientInquiryList: React.FC<PatientInquiryListProps> = ({
  inquiries,
  id,
}) => {
  const { setComponentVisibility } = useComponentPortalContext();

  const { trackEvent } = useAnalytics();

  if (isEmpty(inquiries)) {
    return (
      <EmptySectionCard
        caption="There are no inquiries associated with this patient"
        id={id}
      />
    );
  }

  const handleCloseInquiryDetailDrawer = () => {
    setComponentVisibility({
      component: PortalComponent.INQUIRY_DETAIL_DRAWER,
      data: null,
      isVisible: false,
    });
    trackEvent(InquiryEvents.detailClosed);
  };

  const handleOpenInquiryDetailDrawer = (inquiryId: string) => {
    setComponentVisibility({
      component: PortalComponent.INQUIRY_DETAIL_DRAWER,
      data: { inquiryId, onClose: handleCloseInquiryDetailDrawer },
      isVisible: true,
    });
    trackEvent(InquiryEvents.detailOpened);
  };

  return (
    <>
      {inquiries.map((inquiry) => (
        <InquiryEnrollmentCard
          avatarTooltipWrapper={({ children, providerExternalId }) => (
            <ProviderAvatarTooltipWrapper
              providerExternalId={providerExternalId}
            >
              {children}
            </ProviderAvatarTooltipWrapper>
          )}
          channel={inquiry.channel.name}
          createdAt={new Date(inquiry.inquiryDate)}
          id={id}
          key={inquiry.id}
          modeOfInquiry={inquiry.informationSource.name}
          onClick={() => handleOpenInquiryDetailDrawer(inquiry.id)}
          providers={getProvidersForAvatar(inquiry.assignedProviders)}
          status={inquiry.status.name}
        />
      ))}
    </>
  );
};

export default PatientInquiryList;
